import React, { useState } from 'react';
import AttachmentsBase from '../../../../components/Attachments';

const Attachments = AttachmentsBase as React.ComponentType<any>;
import { ATTACHMENTS_COLUMNS } from '../../../../globalConstants';

interface AllAttachmentsProps {
  data: { id: any; all_files: any[] };
  refetch: () => void;
  canEdit: boolean;
}

const AllAttachments = ({
  data: { id, all_files },
  refetch,
  canEdit,
}: AllAttachmentsProps) => {
  const [isModalOpen, toggleModal] = useState(false);
  const columns = ATTACHMENTS_COLUMNS.slice(0, 3)
    .concat({
      Header: 'Attached In',
      accessor: 'model_type',
      Cell: ({ cell: { value } }) => {
        if (value === 'AppModelsProject') {
          return 'Projects';
        }
        if (value === 'AppModelsClient') {
          return 'Clients';
        }
        if (value === 'AppModelsFunder') {
          return 'Funders';
        }
        return 'Vault';
      },
    })
    .concat(ATTACHMENTS_COLUMNS.slice(3, 5));

  return (
    <Attachments
      canEdit={canEdit}
      data={all_files}
      isModalOpen={isModalOpen}
      onClick={() => toggleModal(true)}
      onClose={() => toggleModal(false)}
      modelId={id}
      modelType="App\Models\Vault"
      clientId={id}
      refetch={refetch}
      columns={columns}
      disabled={!canEdit}
    />
  );
};

export default AllAttachments;
